import styled from 'styled-components';

export const ProposalsGrid = styled.div`
  display: grid;
  grid-template-columns: 50px auto auto auto auto;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px;
  width: 100%;
  border: 1px solid var(--colors-neutral-border-colorborder);
  border-radius: 8px;
  margin-bottom: 24px;
`;

export const ValueContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
`;

export const Counter = styled.h5`
  font-size: 24px;
  color: var(--colors-neutral-text-colortextqua-dark);
  font-weight: var(--typography-fontweight-regular);
`;

export const Label = styled.h5`
  font-size: var(--typography-fontsize-label);
  color: var(--colors-neutral-text-colortextsec-dark);
  font-weight: var(--typography-fontweight-regular);
`;
